import './hero-secondary.css';

export default () => {};
